export default {
  SET_NOTICIAS_CLIENTES_TABLE_HEADERS(state, payload) {
    state.noticiasClientesTableHeaders = payload;
  },
  SET_NOTICIAS_CLIENTES_TABLE_ITEMS(state, payload) {
    state.noticiasClientesTableItems = payload;
  },
  SET_GRUPO_PESSOAS(state, payload) {
    state.grupoPessoas = payload;
  },
  SET_CRIAR_ENVIO_FORM(state, payload) {
    state.criarEnvioForm = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
